export default "__VITE_ASSET__HiI$ugWi__"